module.exports = __webpack_public_path__ + "static/media/4.fd0a67f9.jpg";